export enum TEST_DATA_SYMBOLS {
  RUNTIME_VARIABLE = '$',
  PARAMETER = '@',
  ENVIRONMENT = '*',
  EMAIL = '&',
  PHONE_NUMBER = '%',
  RANDOM = '~',
  DATA_GENERATOR = '!',
  UPLOAD = '^',
}


export function getSymbol(dataType: string): string | undefined {
  switch (dataType) {
    case 'RUNTIME_VARIABLE':
      return TEST_DATA_SYMBOLS.RUNTIME_VARIABLE;
    case 'PARAMETER':
      return TEST_DATA_SYMBOLS.PARAMETER;
    case 'ENVIRONMENT_VARIABLE':
      return TEST_DATA_SYMBOLS.ENVIRONMENT;
    case 'MAIL_BOX':
      return TEST_DATA_SYMBOLS.EMAIL;
    case 'PHONE_NUMBER':
      return TEST_DATA_SYMBOLS.PHONE_NUMBER;
    case 'RANDOM':
      return TEST_DATA_SYMBOLS.RANDOM;
    case 'DATA_GENERATOR':
      return TEST_DATA_SYMBOLS.DATA_GENERATOR;
    case 'UPLOAD':
      return TEST_DATA_SYMBOLS.UPLOAD;
    default:
      return undefined; // Return undefined if the dataType is not recognized
  }
}
